import * as Common from '@/tenant/common';

export class StockReplenishmentCommodity extends Common.ObjectBase{
  constructor(){
    super('StockReplenishmentCommodity')
    this.binders.stockKey = new Common.ModelBinder(Common.StockKey);
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.purchaseReplenishmentUom = new Common.ModelBinder(Common.Conversion);
  }
  public scheduleQuantity: number = 0; // 予定在庫数量
  public beginningTotalStockQuantity: number =0;  //月初在庫数量
  public totalTransferQuantity: number = 0;  // 振替数量
  public purchaseQuantity: number = 0;  // 入荷済み数量
  public salesQuantity: number = 0; // 出荷済み数量
  public schedulePurchaseQuantity: number = 0;  // 入荷待ち数量
  public scheduleSalesQuantity: number = 0; // 出荷待ち数量
  public backPurchaseOrderQuantity: number = 0;  // 発注残数量
  public backSalesOrderQuantity: number = 0; // 受注残数量
  public backPurchaseOrderNoScheduleQuantity: number = 0;  // 発注残数量（入荷予定日なし
  public backSalesOrderNoScheduleQuantity: number = 0; // 受注残数量（出荷予定日なし
  public replenishmentQuantity: number = 0; //補充数量
  public replenishmentUom: Common.Conversion = null; //補充単位
  public minimumStockQuantity: number = 0; //補充基準数量
  public isShortage: boolean = false; // 補充区分
  
  public commodity: Common.Commodity = null;
  public sku: Common.SKU = null;

  public unitPrice: number = 0;
  public taxCode: string = '';
  public answerDeliveryDate: Date = new Date().getCalendarDate();
  public scheduledDeliveryDate: Date = new Date().getCalendarDate();
  
  public purchaseReplenishmentUom:Common.Conversion = null; //発注用補充単位
  public purchaseReplenishmentQuantity: number = 0; //発注用補充数量
  public get quantityScale():number{
    return this.commodity ? this.commodity.quantityScale : 0;
  }

  public set dialogPurchaseReplenishmentUom(conv : Common.Conversion){
    if(conv == null || conv.code == null) this.purchaseReplenishmentUom = null;
    else this.purchaseReplenishmentUom = conv;
  }
  public get dialogPurchaseReplenishmentUom(): Common.Conversion{
    if(this.purchaseReplenishmentUom != null)return this.purchaseReplenishmentUom;
    if(this.commodity != null){
    return (this.commodity as Common.Commodity).getDefaultConversion();
    }
  }
}

export enum ReplenishmentTypes
{
  Commodity=1,
  SKU=2,
}
export enum shortageTypes
{
  None=0,
  IsTraget=1,
  IsShort=2,
}
export enum showMinusTypes
{
  None=0,
  MinusOnly=1,
  MinusOnly_IncludeNoSchedule=2,
}
export class StockReplenishmentCommodityQuery extends Common.LoadQuery {
  constructor(){
    super('StockReplenishmentCommodityQuery',StockReplenishmentCommodity);
  }

  public baseDate: Date = new Date().getCalendarDate();
  public supplier: Common.Counterpart = null;
  public supplierCode: string = "";
  public replenishmentType: ReplenishmentTypes = ReplenishmentTypes.Commodity;  // 補充対象
  public isShortage: shortageTypes = shortageTypes.None; // 補充区分
  public showMinusType: showMinusTypes = showMinusTypes.None; // 予定在庫数量（マイナスのみ表示
  //日付フラグ
  public baseDateFlag: Common.dateFlags = Common.dateFlags.default;  
  public commodityCategory1: number = null;
  public commodityCategory2: number = null;
  public commodityCategory3: number = null;
  public commodityCategory4: number = null;
  public commodityCategory5: number = null;
  public commodityCategory6: number = null;
  // コード・名称・型番
  public codeNameModel: string = "";
}

export class CreatePuchaseOrderFromCommodityQuery extends Common.Query {
    constructor(){
        super('CreatePuchaseOrderFromCommodityQuery',new Common.ModelBinder(Common.Order,true));
    }
    public stockReplenishmentCommodityList: Array<Common.StockReplenishmentCommodity>;
    public currencyCode: string = null;
    public pic: string;
    public segment: Common.Segment;
    public workflowId: number=0;    
    public actionId: number=0;
    public addExistPurchaseOrder: boolean;
    public supplier: Common.Counterpart;
}

export class HasMinimumStockQuantityCountQuery extends Common.Query{
  constructor(){
        super('HasMinimumStockQuantityCountQuery', null); //戻り値はint
  }
  public replenishmentType : ReplenishmentTypes = ReplenishmentTypes.Commodity;
}

export class StockReplenishmentCommodityExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super(sheetName,loadQuery);
    this.className = "StockReplenishmentCommodityExportQuery";
  }
}